import { useParams, useSearchParams } from "react-router-dom"
import { useViewer } from "~/auth/use-viewer"
import { MyProfileScreen } from "./my-profile-screen"
import { UserProfileScreen } from "./user-profile-screen"
import { useProfileData } from "./hooks/use-profile-data"

export const HandleProfileScreen = () => {
  const { handle } = useParams<{ handle: string }>()
  const [searchParams] = useSearchParams()
  const { viewer } = useViewer()

  const csrid = searchParams.get("csrid")
  const { user } = useProfileData(handle, csrid || undefined)

  // Determine if this is the viewer's own profile
  const isOwnProfile = viewer?.handle === user?.handle

  // Route to appropriate component based on ownership
  if (isOwnProfile) {
    return <MyProfileScreen />
  }

  return <UserProfileScreen />
}
